import {
  ComboboxContext
} from "../__chunks/5VGBBGF5.js";
import {
  useCompositeSeparator
} from "../__chunks/RY6ZOIHR.js";
import "../__chunks/D3IXN5NP.js";
import "../__chunks/WJ37OVG2.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/combobox/combobox-separator.ts
import { useContext } from "react";
import { invariant } from "@ariakit/core/utils/misc";
var useComboboxSeparator = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useContext(ComboboxContext);
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "ComboboxSeparator must be wrapped in a ComboboxList or ComboboxPopover component"
    );
    props = useCompositeSeparator(__spreadValues({ store }, props));
    return props;
  }
);
var ComboboxSeparator = createComponent(
  (props) => {
    const htmlProps = useComboboxSeparator(props);
    return createElement("hr", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  ComboboxSeparator.displayName = "ComboboxSeparator";
}
export {
  ComboboxSeparator,
  useComboboxSeparator
};
